module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-select', {
    ref: "select",
    attrs: {
      "item-text": "text",
      "item-value": "index",
      "items": _vm.normalizedOptions,
      "label": _vm.label,
      "required": _vm.required,
      "autocomplete": ""
    },
    on: {
      "blur": _vm.blur
    },
    model: {
      value: (_vm.localIndex),
      callback: function($$v) {
        _vm.localIndex = $$v
      },
      expression: "localIndex"
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-05870d5e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ObjectSelect.vue
// module id = 1047
// module chunks = 1